import React from "react";
import {
  ShieldCheck,
  Gauge,
  Headphones,
  TrendingUp,
  ArrowUpRight,
  Users,
  BrainCircuit,
  Globe2,
} from "lucide-react";

const heroImage =
  "/Images/services/enviromental/investigation/investigacion.webp";

// NUESTRO ENFOQUE
const approachItems = [
  {
    title: "Rigor científico",
    desc: "Aplicamos metodologías validadas y estándares reconocidos para generar resultados confiables.",
    icon: ShieldCheck,
  },
  {
    title: "Conocimiento del territorio",
    desc: "Analizamos cada ecosistema considerando sus condiciones y particularidades ambientales.",
    icon: Gauge,
  },
  {
    title: "Innovación aplicada",
    desc: "Utilizamos tecnología avanzada y metodologías técnicas especializadas en campo y laboratorio.",
    icon: TrendingUp,
  },
  {
    title: "Soporte a decisiones",
    desc: "Generamos información clave para la gestión ambiental y el cumplimiento normativo.",
    icon: Headphones,
  },
];

// EVENTOS Y PUBLICACIONES
const sectorEvents = [
  {
    title: "VIII Cumbre del petróleo, Gas y Energía -2025",
    description:
      "Participación en espacios de discusión técnica, innovación y sostenibilidad del sector energético.",
    image: "/Images/services/enviromental/investigation/vlll-cumbre.webp",
    link: "/Docs/PLANTILLA ARTÍCULOS TÉCNICOS 2025 - XXII.pdf",
  },
  {
    title: "ACIPET 2025",
    description:
      "Caracterización de comunidades hidrobiológicas para el reconocimiento de bioindicadores de calidad de agua.",
    image: "/Images/services/enviromental/investigation/acipet.webp",
    link: "/Docs/PLANTILLA ARTÍCULOS TÉCNICOS 2025 - XXII.pdf",
  },
];

const Equipament = () => {
  return (
    <>
      {/* HERO */}
      <section className="overflow-hidden">
        <div className="relative h-[420px] sm:h-[500px] md:h-[620px] overflow-hidden">
          <img
            src={heroImage}
            alt="Alquiler de equipos ambientales"
            className="w-full h-full object-cover"
          />

          <div className="absolute inset-0 bg-black/40" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-transparent" />

          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <div className="max-w-2xl">
                <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#ee7d32]/15 border border-[#ee7d32]/30 text-[#ee7d32] text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] backdrop-blur-sm">
                  Investigación e Innovación
                </span>

                <h1 className="mt-6 text-4xl sm:text-5xl md:text-6xl xl:text-7xl font-bold text-white leading-[0.95]">
                  Investigación y desarrollo
                  <span className="text-[#ee7d32]"> I+D</span>
                </h1>

                <p className="mt-6 text-white/80 text-sm sm:text-base md:text-lg leading-7 max-w-xl">
                  Investigación ambiental basada en evidencia científica,
                  monitoreo de recursos naturales y análisis técnico
                  especializado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NUESTRO ENFOQUE */}
      <section className="relative py-20 md:py-20 bg-[white] overflow-hidden">
        <div className="absolute top-0 right-0 w-[420px] h-[420px] bg-[#ee7d32]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[350px] h-[350px] bg-[#ee7d32]/5 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full mb-5" />

            <h2 className="mt-6 text-4xl sm:text-5xl md:text-6xl font-bold text-[#111] leading-[1]">
              Nuestro <span className="text-[#ee7d32]">Enfoque</span>
            </h2>

            <p className="mt-6 text-base sm:text-lg text-[#555] leading-8 max-w-2xl">
              Desarrollamos soluciones ambientales basadas en evidencia
              científica, integrando tecnología, conocimiento del territorio y
              metodologías especializadas.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mt-16 py-8">
            {approachItems.map((item, index) => {
              const Icon = item.icon;

              return (
                <div
                  key={index}
                  className="group relative bg-white rounded-3xl p-8 pt-14 text-center shadow-[0_20px_60px_rgba(0,0,0,0.06)] hover:shadow-[0_30px_80px_rgba(238,125,50,0.18)] transition-all duration-500 hover:-translate-y-2"
                >
                  <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-20 h-20 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                    <Icon
                      className="w-8 h-8"
                      stroke="#ffff"
                      strokeWidth={2.2}
                    />
                  </div>

                  <h3 className="text-[18px] font-[800] text-[#111]">
                    {item.title}
                  </h3>

                  <p className="text-sm text-gray-600 leading-[1.6] mt-3">
                    {item.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* EVENTOS Y PUBLICACIONES */}
      <section className="relative py-24 bg-[#f8f7f4] overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mb-16">
            <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full mb-5" />

            <h2 className="mt-5 text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              Eventos
            </h2>

            <p className="mt-5 text-lg leading-8 text-gray-600">
              Compartimos experiencias, investigaciones y participación en
              espacios técnicos y ambientales.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
            {sectorEvents.map((item, index) => (
              <div
                key={index}
                className="group bg-white rounded-[30px] overflow-hidden border border-gray-100 shadow-sm hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 flex flex-col h-full"
              >
                <div className="relative h-[240px] overflow-hidden flex-shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />

                  <div className="absolute top-5 left-5">
                    <span className="px-4 py-2 rounded-full bg-white/90 backdrop-blur-md text-[#ee7d32] text-xs font-bold uppercase tracking-[0.18em] shadow-sm">
                      Evento
                    </span>
                  </div>
                </div>

                <div className="p-8 flex flex-col flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 leading-tight min-h-[72px] mb-4 group-hover:text-[#ee7d32] transition-colors duration-300">
                    {item.title}
                  </h3>

                  <p className="text-gray-600 leading-8 text-[15px] flex-1 mb-8">
                    {item.description}
                  </p>

                  <div className="pt-2">
                  <a
  href={item.link}
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center gap-3 px-6 py-3 rounded-2xl bg-[#ee7d32] text-white font-semibold transition-all duration-300 hover:bg-[#d96d26] hover:shadow-lg hover:shadow-[#ee7d32]/20 group/button"
>
  Ver documento
  <ArrowUpRight
    size={18}
    strokeWidth={2.2}
    stroke="white"
    className="transition-all duration-300 group-hover/button:translate-x-1 group-hover/button:-translate-y-1"
  />
</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* INNOVACIÓN AMBIENTAL */}
      <section className="relative py-24 bg-white overflow-hidden">
        <div className="absolute top-0 right-0 w-[420px] h-[420px] bg-[#ee7d32]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[350px] h-[350px] bg-[#ee7d32]/5 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-[4px] bg-[#ee7d32] rounded-full" />
            </div>

            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#111] leading-[1] tracking-[-2px]">
              Comprometidos con la
              <span className="block text-[#ee7d32] mt-2">
                innovación ambiental
              </span>
            </h2>

            <p className="mt-7 text-lg text-[#555] leading-9 max-w-2xl">
              Nos mantenemos a la vanguardia de las tendencias y mejores
              prácticas ambientales, fortaleciendo continuamente nuestras
              capacidades y redes de colaboración.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 mt-20">
            <div className="group relative bg-white rounded-[32px] p-8 pt-16 border border-gray-200 shadow-[0_15px_45px_rgba(0,0,0,0.08)] hover:shadow-[0_30px_70px_rgba(238,125,50,0.14)] transition-all duration-500 hover:-translate-y-2 overflow-visible">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#ee7d32]/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-all duration-500" />

              <div className="absolute -top-10 left-8 w-20 h-20 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-[0_15px_35px_rgba(238,125,50,0.35)] group-hover:scale-105 transition-transform duration-300">
                <Users className="w-8 h-8" stroke="white" strokeWidth={2.2} />
              </div>

              <span className="absolute top-7 right-7 text-4xl font-black text-gray-100">
                01
              </span>

              <h3 className="text-2xl font-bold text-[#111]">Colaboración</h3>

              <p className="mt-5 text-gray-600 leading-8">
                Trabajamos en red con instituciones y expertos.
              </p>
            </div>

            <div className="group relative bg-white rounded-[32px] p-8 pt-16 border border-gray-200 shadow-[0_15px_45px_rgba(0,0,0,0.08)] hover:shadow-[0_30px_70px_rgba(238,125,50,0.14)] transition-all duration-500 hover:-translate-y-2 overflow-visible">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#ee7d32]/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-all duration-500" />

              <div className="absolute -top-10 left-8 w-20 h-20 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-[0_15px_35px_rgba(238,125,50,0.35)] group-hover:scale-105 transition-transform duration-300">
                <BrainCircuit
                  className="w-8 h-8"
                  stroke="white"
                  strokeWidth={2.2}
                />
              </div>

              <span className="absolute top-7 right-7 text-4xl font-black text-gray-100">
                02
              </span>

              <h3 className="text-2xl font-bold text-[#111]">Capacidades</h3>

              <p className="mt-5 text-gray-600 leading-8">
                Invertimos en conocimiento, tecnología y talento.
              </p>
            </div>

            <div className="group relative bg-white rounded-[32px] p-8 pt-16 border border-gray-200 shadow-[0_15px_45px_rgba(0,0,0,0.08)] hover:shadow-[0_30px_70px_rgba(238,125,50,0.14)] transition-all duration-500 hover:-translate-y-2 overflow-visible">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#ee7d32]/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-all duration-500" />

              <div className="absolute -top-10 left-8 w-20 h-20 bg-[#ee7d32] rounded-full flex items-center justify-center shadow-[0_15px_35px_rgba(238,125,50,0.35)] group-hover:scale-105 transition-transform duration-300">
                <Globe2 className="w-8 h-8" stroke="white" strokeWidth={2.2} />
              </div>

              <span className="absolute top-7 right-7 text-4xl font-black text-gray-100">
                03
              </span>

              <h3 className="text-2xl font-bold text-[#111]">Vanguardia</h3>

              <p className="mt-5 text-gray-600 leading-8">
                Aplicamos las mejores prácticas y estándares internacionales.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Equipament;
